module.exports = __webpack_public_path__ + "img/light.8ecb1152.png";